import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ThemeProvider } from "@mui/material";
import { design1Theme, design2Theme, design3Theme } from "./Themes.js";

import { useGetUserSettingsByIdQuery } from "../redux/features/settings/setttingsApi.js";
import { setUserSettings } from "../redux/features/settings/settingsSlice.js";
import { useAuthDeviceQuery } from "../redux/features/auth/authApi.js";
const themes = {
  1: design1Theme,
  2: design2Theme,
  3: design3Theme,
};

export default function ThemeEngine({ children }) {
  const dispatch = useDispatch();
  const {
    data: deviceSettings,
    isError: isDeviceError,
    isLoading: isDeviceLoading,
  } = useAuthDeviceQuery();
  const {
    data: userSettings,
    isError,
    isLoading,
  } = useGetUserSettingsByIdQuery(deviceSettings?.device_id, {
    skip: !deviceSettings,
  });

  useEffect(() => {
    if (userSettings && !isLoading && !isError) {
      dispatch(setUserSettings(userSettings));
    }
  }, [userSettings, dispatch, isLoading, isError]);

  const designId = (userSettings && userSettings?.design_id) || 1;

  return <ThemeProvider theme={themes[designId]}>{children}</ThemeProvider>;
}
